import React from 'react';
import PropTypes from 'prop-types';
import SpeakButton from '../../common/SpeakButton/SpeakButton';
import './attempts-answer-block.scss';

const AttemptsAnswerBlock = ({title, text, margin, questionClass, translateAnswers, lang}) => {
  const classes = [margin, questionClass].filter(Boolean).join(' ');
  return (
    <div className={`attempts-answer-block ${classes}`}>
      <span className='attempts-answer-block__title'>{title}</span>
      {translateAnswers 
      ? translateAnswers.map((answer, idx) => (
        <div className='attempts-answer-block__item' key={idx}>
          <div className='attempts-answer-block__number'>{idx + 1}.</div>
          <span className='attempts-answer-block__question'>
            {answer}
          </span>
          <SpeakButton text={answer} lang={lang} className='attempts-answer-block__speak' />
        </div>
      ))
      : <span className='attempts-answer-block__row'>
        <span className='attempts-answer-block__question'>
          {text}
        </span>
        <SpeakButton text={text} lang={lang} className='attempts-answer-block__speak' />
      </span>}
  </div>
  );
};

AttemptsAnswerBlock.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  margin: PropTypes.string,
  questionClass: PropTypes.string,
  translateAnswers: PropTypes.array,
  lang: PropTypes.string
};

export default AttemptsAnswerBlock;